/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFolderUnderline: {
  name: 'folder-underline';
  data: string;
} = {
  name: 'folder-underline',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h4.586A2 2 0 0 1 10 1.586L12.414 4H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-7v2h6a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h6v-2H4a2 2 0 0 1-2-2V3Zm10 13h8V6h-7.586A2 2 0 0 1 11 5.414L8.586 3H4v13h8Z" fill="currentColor"/></svg>`,
};
